import { inject, Injectable } from '@angular/core';
import { Device } from '@capacitor/device';
import { Preferences } from '@capacitor/preferences';
import { TranslateService } from '@ngx-translate/core';
import { from, switchMap } from 'rxjs';

import { AppService } from './app.service';
import { AuthService } from './auth.service';
import { LANGUAGE } from '../constants/language.constant';
import { STORAGE_KEY } from '../constants/storage.constant';

@Injectable({
  providedIn: 'root'
})
export class StartupService {
  private readonly appService = inject(AppService);
  private readonly translate = inject(TranslateService);
  private readonly authService = inject(AuthService);

  private async getInitialLanguage(): Promise<string> {
    const saved = await Preferences.get({ key: STORAGE_KEY.LANGUAGE });
    if (saved && saved.value) {
      return saved.value.toLowerCase();
    }

    const deviceLang = await Device.getLanguageCode();
    if (deviceLang && deviceLang.value) {
      return deviceLang.value.toLowerCase();
    }

    return LANGUAGE.EN;
  }

  public initializeApp() {
    // determine language
    // check token - auth state
    // get app info
    return from(this.getInitialLanguage()).pipe(
      switchMap(language => {
        const use = language.indexOf(LANGUAGE.ZH) > -1 ? LANGUAGE.ZH : LANGUAGE.EN;
        this.translate.use(use);
        return from(Preferences.set({ key: STORAGE_KEY.LANGUAGE, value: use }));
      }),
      switchMap(() => this.authService.validateAuthToken()),
      switchMap(() => this.appService.getAppInfo())
    );
  }
}
